/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiMasterDataSimpleValueValueByMasterTypeGet$Params {
  masterType?: string;

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiMasterDataSimpleValueValueByMasterTypeGet(http: HttpClient, rootUrl: string, params?: ApiMasterDataSimpleValueValueByMasterTypeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterDataSimpleValueValueByMasterTypeGet.PATH, 'get');
  if (params) {
    rb.query('masterType', params.masterType, {});
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    })
  );
}

apiMasterDataSimpleValueValueByMasterTypeGet.PATH = '/api/MasterData/SimpleValue/ValueByMasterType';
